import { Link, ListItem } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { legislationHref } from "routes/schedule/lib/legislation-href.mjs"

export function ScheduleCommentaryLegislationItem({ item }) {
    return (
        <ListItem data-cy="schedule-commentary-legislation-item" sx={{ display: "list-item", py: 0.25 }}>
            <If value={Boolean(item?.url)}>
                <Link href={legislationHref(item.url)} target="_blank" rel="noopener noreferrer" underline="hover">
                    {item.html ?? item.url}
                </Link>
                <Else>{item?.html}</Else>
            </If>
        </ListItem>
    )
}
